import React, { useMemo } from 'react';
import styled from 'styled-components';
import { withTheme } from '../../../../theme';
import { DurationBetween } from './OrRoomReadyTime';

const Timer = styled.div`
  display: flex;
  justify-content: left;
  align-items: left;
  font-size: ${props => (props.$humanCompact ? '0.8em' : '1em')};
  font-family: monospace;
  font-weight: 500;
  opacity: 0.75;
  color: ${withTheme(theme => theme.textColor.string())};
`;

const CleaningTime = props => {
  const cleaningStartedAtDefault = useMemo(() => new Date(), []);

  return (
    <Timer $humanCompact={props?.humanCompact}>
      Cleaning Time:{' '}
      <DurationBetween
        since={props?.room?.cleaningStartedAt || cleaningStartedAtDefault}
        until={props?.room?.turnoverStartedAt}
      />
    </Timer>
  );
};

export default CleaningTime;
